const updateType = (mediaArray) => {
  mediaArray.forEach((mediaItem) => {
    if (mediaItem.type === 'picture') {
      mediaItem.type = 'image'
    }
  })
}

const CMV2Rule = ({ item }) => {
  if (item.teaser) {
    Object.assign(item, item.teaser)
    const propertyMap = {
      teaserSubTitle: 'subTitle',
      teaserSubTitlePlain: 'subTitlePlain',
      teaserPreTitle: 'preTitle',
      teaserPreTitlePlain: 'preTitlePlain'
    }
    Object.entries(propertyMap).forEach(([oldProp, newProp]) => {
      if (item[oldProp]) {
        item[newProp] = item[oldProp]
        delete item[oldProp]
      }
    })
    delete item.teaser
  }
  if (item.media) {
    updateType(item.media)
    item.pictures = item.media
    item.picturesAndMedia = item.media
    delete item.media
  }
  if (item.targets && !item.target) {
    item.target = { ...item.targets[0]?.target }
  }
  if (item.target && item.target.teaser) {
    const { teaser, ...rest } = item.target
    item.target = {
      ...rest,
      ...teaser
    }
  }
  return item
}

export default CMV2Rule
